import { render, staticRenderFns } from "./hanDongSwitch.vue?vue&type=template&id=35748762&scoped=true"
import script from "./hanDongSwitch.vue?vue&type=script&lang=js"
export * from "./hanDongSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35748762",
  null
  
)

export default component.exports